import React from "react";
import { Link } from "react-router-dom";

const CommitmentCard = ({ title, description }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-l-4 border-[#71b340]">
      <h2 className="text-xl font-bold text-gray-800 mb-3">{title}</h2>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

const CommitmentSection = () => {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
          OUR <span className="text-[#71b340]">COMMITMENTS</span>
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <CommitmentCard
            title="Empowerment Through Inclusivity"
            description="We strive to create a society that recognizes and values the abilities of every individual."
          />
          <CommitmentCard
            title="Resource Hub"
            description="Access a wealth of resources, information, and tools tailored to support and enhance the lives of individuals with disabilities."
          />
          <CommitmentCard
            title="Inspiring Stories"
            description="Discover powerful narratives that showcase the achievements and potential of individuals with disabilities."
          />
        </div>

        <div className="text-center mt-8">
          <p className="text-lg text-gray-600 mb-4">Let's Explore Together</p>
          <Link 
            to="/explore" 
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-8 rounded-md transition-colors duration-300 shadow-md hover:shadow-lg"
          >
            Click to Explore
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CommitmentSection;